import { memo, useState } from "react";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import {
  AddArticlesFragment,
  type AddArticlesSelection,
} from "@coworker/apprestructured/src/task-management/components/AddArticlesFragment/AddArticlesFragment";
import Demo from "./Demo/Demo";
import Highlight from "./Highlight/Highlight";
import Name from "./Name/Name";

function AddArticlesFragmentDemo() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectionSummary, setSelectionSummary] = useState("");

  const handleSubmit = (selection: AddArticlesSelection) => {
    setSelectionSummary(
      `${selection.articles.length} ${selection.mode === "attach" ? "selected" : "entered"} article(s)`
    );
    setIsOpen(false);
  };

  return (
    <Demo>
      <Name>AddArticlesFragment</Name>
      <Highlight>
        <FixaButton type="primary" onClick={() => setIsOpen(true)}>
          Open Add articles
        </FixaButton>
        {selectionSummary && (
          <FixaText textStyle="Body.M">{selectionSummary}</FixaText>
        )}
        {isOpen && (
          <AddArticlesFragment
            onClose={() => setIsOpen(false)}
            onSubmit={handleSubmit}
          />
        )}
      </Highlight>
    </Demo>
  );
}

export default memo(AddArticlesFragmentDemo);
